import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { SpendingRulesEntity } from "../entities/RewardsSpendingRulesEntities";

export interface RewardsSpendingRulesState {
    spendingRulesList: SpendingRulesEntity[];
}

const createInitialState = (): RewardsSpendingRulesState => ({
    spendingRulesList: [],
});

@singleton()
@StoreConfig({ name: "RewardsSpendingRulesStore" })
class RewardsSpendingRulesStore extends BaseStore<RewardsSpendingRulesState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsSpendingRulesStore;
